import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
const DefaultNavigationContext = {
    show: false,
    setShow: (show) => { },
    anchorEl: null,
    setAnchorEl: (anchorEl) => { },
    createGroupType: '',
    setCreateGroupType: (createGroupType) => { },
    deviceType: undefined,
    setDeviceType: (deviceType) => { },
    domain: undefined,
    setDomain: (domain) => { },
    newObject: undefined,
    setNewObject: (newObject) => { },
};
export const NavigationContext = createContext(DefaultNavigationContext);
export const NavigationContextProvider = ({ children }) => {
    const setShow = (show) => {
        switch (typeof show) {
            case 'boolean':
                setState((state) => ({ ...state, show }));
                break;
            case 'function':
                setState((state) => ({ ...state, show: show(state.show) }));
                break;
        }
    };
    const setAnchorEl = (anchorEl) => {
        switch (typeof anchorEl) {
            case 'object':
                setState((state) => ({ ...state, anchorEl }));
                break;
            case 'function':
                setState((state) => ({ ...state, anchorEl: anchorEl(state.anchorEl) }));
                break;
        }
    };
    const setCreateGroupType = (createGroupType) => {
        switch (typeof createGroupType) {
            case 'string':
                setState((state) => ({ ...state, createGroupType }));
                break;
            case 'function':
                setState((state) => ({ ...state, createGroupType: createGroupType(state.createGroupType) }));
                break;
        }
    };
    const setDeviceType = (deviceType) => {
        switch (typeof deviceType) {
            case 'number':
                setState((state) => ({ ...state, deviceType }));
                break;
            case 'function':
                setState((state) => ({ ...state, deviceType: deviceType(state.deviceType) }));
                break;
        }
    };
    const setDomain = (domain) => {
        switch (typeof domain) {
            case 'string':
                setState((state) => ({ ...state, domain }));
                break;
            case 'function':
                setState((state) => ({ ...state, domain: domain(state.domain) }));
                break;
        }
    };
    const setNewObject = (newObject) => {
        switch (typeof newObject) {
            case 'undefined':
            case 'object':
                setState((state) => ({ ...state, newObject }));
                break;
            case 'function':
                setState((state) => ({ ...state, newObject: newObject(state.newObject) }));
                break;
        }
    };
    const initialState = {
        show: false,
        setShow,
        anchorEl: null,
        setAnchorEl,
        createGroupType: '',
        setCreateGroupType,
        deviceType: undefined,
        setDeviceType,
        domain: undefined,
        setDomain,
        newObject: undefined,
        setNewObject,
    };
    const [state, setState] = useState(initialState);
    return _jsx(NavigationContext.Provider, { value: state, children: children });
};
